/* eslint-disable */ 
import _ from 'lodash'
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { divisionPlayerFilter } from '../../../utils/functions';
import { DIVISIONS,PlayersHeaders } from '../../../utils/constants';
import  Navwrapper  from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import { getPlayersBySeason,getSeasonsRanking } from '../api'
import { exportCSV, tableOptions} from '../common'
export default class PlayersPage extends Component {

    constructor(props) {    super(props);
        const { match } = this.props
        this.state = {      
            seasons:[],
            playersData:[],
            seasonId: 0,
            events: "0",
            players: "0",
            currentSeason: '',
            category:"0",
            // pageTitle:"Top Players",
            categoryTitle:"Traditional Avg.",
            eventsTitle:"All Events",
            playersTitle:"Top Players"            
        };
        this.handleActiveSeasonChange = this.handleActiveSeasonChange.bind(this)
        this.handleCategoryChange = this.handleCategoryChange.bind(this)
        this.handleEventsChange = this.handleEventsChange.bind(this)
        this.handlePlayersChange = this.handlePlayersChange.bind(this)
      }

      componentDidMount() {
         const _this = this
        getSeasonsRanking().then(function(response) {
           const seasons = response.data 
          _this.setState({currentSeason:response.data[0].seasonName}) 
          _this.setState({seasonId:seasons[0].seasonId}) 
        //   _this.setState({pageTitle:'Traditional Avg. All Events Top Players'})
          getPlayersBySeason(_this.state.seasonId,_this.state.events,_this.state.players,_this.state.category).then(function(response){
              _this.setState({playersData: response.data})  
           })
           _this.setState({ seasons:seasons })         
        })                  
      }          

      setActiveSeasonsOptions()
        {
          const { seasons } = this.state
          const option = seasons.map((season) => {
            return(<option value={season.seasonId} key={season.seasonId}>{season.seasonName}</option>)
          })
          return option
      } 

      handleActiveSeasonChange(event){
        const _this = this
        const seasonId = event.target.value
        const selectedSeason = _.find(_this.state.seasons,['seasonId',parseInt(seasonId)])
        _this.setState({currentSeason:selectedSeason.seasonName}) 
        _this.setState({seasonId:seasonId})
        
        getPlayersBySeason(seasonId,_this.state.events,_this.state.players,_this.state.category).then(function(response){
           _this.setState({playersData: response.data})  
        })        
      }    
      
      playerNameFormatter(cell, row ) {
        var link = `/playerProfile/${row.seasonId}/${row.playerId}`;
        return <Link to={link}>{cell}</Link>;      
      }  
    
      handleCategoryChange(event) {
          const _this = this
          const category = event.target.value;
          _this.setState({category:category});
          if (category==="0"){
             _this.setState({categoryTitle:"Traditional Avg."});
          }
          else {
            _this.setState({categoryTitle:"Avg. Differential"});
          }
          getPlayersBySeason(_this.state.seasonId,_this.state.events,_this.state.players,category).then(function(response){
           _this.setState({playersData: response.data})  
          })          
      }

      handleEventsChange(event) {
        const _this = this
        const events = event.target.value;
        if (events==="0"){
            _this.setState({eventsTitle:"All Events"});
        }
        else {
           _this.setState({eventsTitle:"Tier 1 Events"});
        }
        _this.setState({events:events});
        getPlayersBySeason(_this.state.seasonId,events,_this.state.players,_this.state.category).then(function(response){
         _this.setState({playersData: response.data})  
        })          
      }      

      handlePlayersChange(event) {
        const _this = this
        const players = event.target.value;
        if (players==="0"){
            _this.setState({playersTitle:"Top Players"});
        }
        if (players==="1"){
            _this.setState({playersTitle:"Top Rookies"});
        }
        if (players==="2"){
            _this.setState({playersTitle:"All Players"});
        }        
        _this.setState({players:players});
        getPlayersBySeason(_this.state.seasonId,_this.state.events,players,_this.state.category).then(function(response){
         _this.setState({playersData: response.data})  
        })          
      }          

    render() {
        const _this = this
        const playersAll=this.state.playersData         
        const menPlayers = playersAll.filter( (dataItem) => divisionPlayerFilter(dataItem, DIVISIONS.MENPLAYERS));
        const womenPlayers = playersAll.filter( (dataItem) => divisionPlayerFilter(dataItem, DIVISIONS.WOMENPLAYERS));
        return (
            <div>  
            <Navwrapper />
            
            <div className="container-fluid">
                <Row>
                    <div className="pageHeading" >
                    <div className="archiveDropDown">
                                <div >
                                    <div className="titleWrap">
                                        <label className="archiveLabel">Past Season: </label>
                                    </div>
                                    <div className="valueWrap" >
                                        <select onChange={this.handleActiveSeasonChange}>
                                            {this.setActiveSeasonsOptions()}
                                        </select>
                                    </div>
                                </div>
                            </div>                       
                        <h4>
                            {_this.state.currentSeason}                        
                        </h4>
                        <h4 >
                                {_this.state.categoryTitle+" "+_this.state.eventsTitle+" "+_this.state.playersTitle}
                        </h4>
                    </div>
                </Row>      
                <Row>          
                    <Col xs={2}  >
                        <div className="playersLeftColumn" >

                            <div className="container" />

                            <Row/>                
                            <Row>
                                <label>Category</label>
                            </Row>

                                <div className="react-responsive-container">
                                    <div className="radio">
                                        <label>
                                            <input
                                            id="perfCategory-1"
                                            type="radio"
                                            value="0"
                                            checked={this.state.category === "0"}
                                            onChange={this.handleCategoryChange}
                                            />
                                            Traditional Avg.
                                        </label>                                        
                                    </div>

                                    <div className="radio">
                                        <label>
                                            <input
                                             id="perfCategory-2"
                                            type="radio"
                                            value="1"
                                            checked={this.state.category === "1"}
                                            onChange={this.handleCategoryChange}
                                            />
                                            Avg. Differential
                                        </label>                                        
                                    </div>  
                                </div>

                            <Row/>

                            <Row>
                                <label>Events</label>
                            </Row>

                            <div className="container">
                                <div className="radio">
                                    <label>
                                            <input
                                            id="event-1"
                                            type="radio"
                                            value="0"
                                            checked={this.state.events === "0"}
                                            onChange={this.handleEventsChange}
                                            />
                                            All
                                    </label>                                       
                                </div>

                                <div className="radio">
                                    <label>
                                            <input
                                            id="event-2"
                                            type="radio"
                                            value="1"
                                            checked={this.state.events === "1"}
                                            onChange={this.handleEventsChange}
                                            />
                                            Tier 1
                                    </label>                                       
                                </div>  
                            </div>                        

                            <Row/>

                            <Row>
                                <label>Players</label>
                            </Row>
                            <div className="container">
                                <div className="radio">
                                    <label>
                                            <input
                                            id="player-0"
                                            type="radio"
                                            value="0"
                                            checked={this.state.players === "0"}
                                            onChange={this.handlePlayersChange}
                                            />
                                            Top Players
                                    </label>                                        
                                </div>

                                <div className="radio">
                                    <label>
                                            <input
                                            id="player-1"
                                            type="radio"
                                            value="1"
                                            checked={this.state.players === "1"}
                                            onChange={this.handlePlayersChange}
                                            //  disabled={true}
                                            />
                                            Top Rookies
                                    </label>                                       
                                </div>  

                                <div className="radio">
                                    <label>
                                            <input
                                            id="player-2"
                                            type="radio"
                                            value="2"
                                            checked={this.state.players === "2"}
                                            onChange={this.handlePlayersChange}
                                            />
                                            All Players
                                    </label>                                                                           
                                </div>                          
                            </div>
                        </div>
                    </Col>            
                    <Col xs={10} >                           
                        <div className="playersRightColumn_"> 
                        <Tabs defaultActiveKey={1} id="players-results-tabs">
                            <Tab eventKey={1} title="MEN">           
                                <BootstrapTable 
                                    data={menPlayers} 
                                    striped 
                                    hover 
                                    options={tableOptions}
                                    pagination               
                                >
                                    <TableHeaderColumn          
                                        dataField="Id" 
                                        isKey 
                                        dataAlign="right" 
                                        data-Visible="false"               
                                        hidden                 
                                    >ID
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="no" width="2%" >NO
                                    </TableHeaderColumn>
                                    <TableHeaderColumn 
                                        dataField="playerName"                                           
                                        dataFormat={_this.playerNameFormatter} 
                                        width="10%" 
                                    >Name
                                    </TableHeaderColumn>  
                                    <TableHeaderColumn 
                                        dataField="schoolName" 
                                        width="10%" 
                                    >SCHOOL
                                    </TableHeaderColumn>                                  
                                    <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="avg" dataAlign="right"  width="6%" dataSort >AVG
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="e" dataAlign="right"  width="2%" >E
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="top1" dataAlign="right"  width="2%" >1
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="top5" dataAlign="right"  width="2%" >5
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="top10" dataAlign="right"  width="2%" >10
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="top25" dataAlign="right"  width="2%" >25
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="favg" dataAlign="right"  width="6%" >F-AVG
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="adiff" dataAlign="right"  width="6%" dataSort>A-DIFF
                                    </TableHeaderColumn>                    
                                </BootstrapTable>
                                { exportCSV(menPlayers,PlayersHeaders,'MenPlayers.csv') }
                            </Tab>
                            <Tab eventKey={2} title="WOMEN">
                                <BootstrapTable 
                                    data={womenPlayers} 
                                    striped 
                                    hover 
                                    options={tableOptions} 
                                    pagination 
                                >
                                    <TableHeaderColumn          
                                        dataField="Id" 
                                        isKey 
                                        dataAlign="right" 
                                        data-Visible="false"               
                                        hidden                 
                                    >ID
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="no" width="2%" >NO
                                    </TableHeaderColumn>
                                    <TableHeaderColumn 
                                        dataField="playerName" 
                                        dataFormat={_this.playerNameFormatter} 
                                        width="10%" 
                                    >Name
                                    </TableHeaderColumn>  
                                    <TableHeaderColumn 
                                        dataField="schoolName"                                           
                                        width="10%" 
                                    >SCHOOL
                                    </TableHeaderColumn>                                  
                                    <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="avg" dataAlign="right"  width="6%" dataSort>AVG
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="e" dataAlign="right"  width="2%" >E
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="top1" dataAlign="right"  width="2%" >1
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="top5" dataAlign="right"  width="2%" >5
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="top10" dataAlign="right"  width="2%" >10
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="top25" dataAlign="right"  width="2%" >25
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="favg" dataAlign="right"  width="6%" >F-AVG
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="adiff" dataAlign="right"  width="6%" dataSort>A-DIFF
                                    </TableHeaderColumn>                          
                                </BootstrapTable>
                                { exportCSV(womenPlayers,PlayersHeaders,'WomenPlayers.csv') }
                            </Tab>
                        </Tabs>
                        </div>
                    </Col>
                </Row>
            </div>

            <Footer />
        </div>
        )    
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/players/index.js